import { Component } from "react";

// Nothing in this codebase had a React error boundary before this - any
// unhandled render error anywhere (a malformed API response, a null
// dereference, a third-party library throwing) took the entire app down
// to a blank white screen with no recovery path, for every visitor,
// regardless of which page they were on. This wraps the whole app once at
// the root, so a crash in one page can never brick the whole site, and a
// real person sees a plain-language message and a way back instead of
// nothing at all.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // console.error, not a silent swallow - still visible in browser devtools
    // and any error-reporting integration added later without more work here.
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          background: "#F7F6F2", color: "#101923", fontFamily: "'DM Sans',sans-serif", padding: 24, textAlign: "center",
        }}>
          <div style={{ fontFamily: "'Cormorant Garamond',Georgia,serif", fontSize: 28, fontWeight: 600, marginBottom: 10 }}>Something went wrong</div>
          <div style={{ fontSize: 14, color: "#68727E", maxWidth: 420, marginBottom: 24, lineHeight: 1.6 }}>
            This page hit an unexpected error. Reloading usually fixes it — nothing you did caused this.
          </div>
          <button onClick={() => window.location.reload()} style={{
            background: "#101923", color: "#FFFFFF", border: "none", borderRadius: 8,
            padding: "11px 24px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif",
          }}>
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
